import React, { cloneElement } from 'react';
import {
  CreateButton,
  TopToolbar,
  ExportButton,
  usePermissions,
} from 'react-admin';
import PropTypes from 'prop-types';

import TourBasicTemplate from '../tours/templates/TourBasicTemplate';

const ListActions = ({ filters, tourConfig, hideCreate, hideFilters }) => {
  const { permissions } = usePermissions();
  return (
    <TopToolbar>
      {!hideFilters && cloneElement(filters, { context: 'button' })}
      {!hideCreate && permissions === 'ADMIN' && <CreateButton />}
      <ExportButton />
      <TourBasicTemplate tourConfig={tourConfig} />
    </TopToolbar>
  );
};

ListActions.propTypes = {
  tourConfig: PropTypes.element.isRequired,
  filters: PropTypes.shape({}).isRequired,
  hideCreate: PropTypes.bool,
  hideFilters: PropTypes.bool,
};

ListActions.defaultProps = {
  hideCreate: false,
  hideFilters: false,
};

export default ListActions;
